// This component is the splash screen that appears when the user first visits the site.

import '../styles/splash.css';
import DetectDevice from './DeviceDetector.js';

import { useMap } from 'react-leaflet/hooks';
import { isMobile } from 'react-device-detect';

const Splash = ({
  setProjectInfo,
  skipSplash,
  setListView,
  redactNFTs,
  setRedactNFTs,
}) => {
  const map = useMap();

  // Hide splash screen with a fade effect
  function cancelSplash() {
    var splash = document.getElementById('splash-screen');
    splash.style.animation = 'fadeOut 1.2s';
    var projTitle = document.getElementsByClassName('project-title')[0];
    projTitle.style.visibility = 'visible';
    setTimeout(clearSplash, 1000);
  }

  // Turn off splash screen's display
  function clearSplash() {
    var splash = document.getElementById('splash-screen');
    splash.style.display = 'none';
  }

  return (
    // Splash screen will be skipped when user navigates directly to a tile url
    // Try going to https://www.latentculture.com/todem/007
    <div id="splash-screen" style={{ display: skipSplash ? 'none' : 'block' }}>
      <div
        id="splash-background"
        onClick={() => {
          cancelSplash();
          map.stop();
        }}
      ></div>

      <div id="splash-info">
        <div id="slide1" className="slide">
          <div id="splash-title">TODEM</div>
          <div className="splash-content">
            <p>a hyper-GIF tapestry</p>
          </div>
        </div>
      </div>

      {/* Web3 versus art mode only available on desktop */}
      {!DetectDevice ? (
        <div className="splash-experience-container ">
          <div
            className="splash-experience-button splash-web3-experience"
            onClick={() => {
              setRedactNFTs(false);
              cancelSplash();
              map.stop();
            }}
          >
            web3 mode
          </div>
          <div
            className="splash-experience-button splash-art-experience"
            onClick={() => {
              setRedactNFTs(true);
              cancelSplash();
              map.stop();
            }}
          >
            art mode
          </div>
        </div>
      ) : null}

      {/* Click anywaywhere for desktop*/}
      {!DetectDevice ? (
        <div
          id="click-anywhere"
          onClick={() => {
            cancelSplash();
            map.stop();
          }}
        >
          CONTENT WARNING:<br></br>
          Contains offensive material. Visit
          <span
            style={{ color: 'white', cursor: 'pointer' }}
            onClick={() => {
              cancelSplash();
              setTimeout(() => {
                setProjectInfo(1);
              }, 1000);
            }}
          >
            &nbsp;info&nbsp;
          </span>
          for more details.<br></br>
          <br></br>
        </div>
      ) : null}

      {/* TODO: This styling should be put into splash.css */}
      {isMobile ? (
        <div
          id="click-anywhere-mobile"
          style={{ visibility: 'visible' }}
          onClick={() => {
            cancelSplash();
            map.stop();
          }}
        >
          <span style={{ fontSize: '20px', letterSpacing: '1px' }}>
            CONTENT WARNING:
          </span>{' '}
          <br></br>
          <span style={{ fontSize: '16px' }}>
            Contains offensive material. Visit
            <span
              style={{ color: 'white', cursor: 'pointer' }}
              onClick={() => {
                cancelSplash();
                setTimeout(() => {
                  setProjectInfo(1);
                }, 1000);
              }}
            >
              &nbsp;info&nbsp;
            </span>
            for more details.{' '}
          </span>{' '}
          <br></br>
          <span style={{ color: 'white' }}>
            ...<br></br>
          </span>
          <span style={{ color: '#5cb2fd', letterSpacing: '1px' }}>
            DESKTOP EXPERIENCE RECOMMENDED
          </span>
          <br></br>
          <span style={{ color: 'white' }}>
            ...<br></br>
          </span>
          <span style={{ fontSize: 20, letterSpacing: 0.2, color: 'white' }}>
            tap to continue
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default Splash;
